import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../../utilities/TabGrid";



export default class BKLogiTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logiBi: [],
            logiBp: [],
            logiPlatnosci: [],

        };
    }

    componentDidMount() {
        this.setState({
            logiBi: this.props.logi.applogidbi,
            logiBp: this.props.logi.applogidbp,
            logiPlatnosci: this.props.logi.platnoscilist
        })
    }

    componentWillReceiveProps(nextprops) {
        this.setState({
            logiBi: nextprops.logi.applogidbi,
            logiBp: nextprops.logi.applogidbp,
            logiPlatnosci: nextprops.logi.platnoscilist
        })
    }


    render() {
        return (<div style={{border: "1px solid #ddd", padding: "5px", marginTop: "5px"}}>

            <h5 style={{fontWeight: "bold", marginTop: "5px"}}>Logi transakcji płatniczych</h5>
            <BootstrapTable data={this.state.logiPlatnosci}
                            options={{noDataText: 'Brak logów'}}
                            hover
            >
                <TableHeaderColumn dataField='id' isKey hidden={false} thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                >ID</TableHeaderColumn>
                <TableHeaderColumn dataField='dataWpisu' hidden={false} thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} dataSort
                                   dataFormat={(cell, row) => {
                                       return <div>{cell.replace("T", " ").substr(0, 19)}</div>
                                   }}
                >Data i godzina</TableHeaderColumn>
                <TableHeaderColumn dataField='trEmail' hidden={false} thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4} dataSort
                >Email</TableHeaderColumn>
                <TableHeaderColumn dataField='trDesc' hidden={false} thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5} dataSort
                >Opis</TableHeaderColumn>
                <TableHeaderColumn dataField='transakcja' hidden={false} thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                >Kod Marcel</TableHeaderColumn>
                <TableHeaderColumn dataField='trId' hidden={false} thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                >Kod TPAY</TableHeaderColumn>
                <TableHeaderColumn dataField='trAmount' hidden={false} thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                >Kwota</TableHeaderColumn>
                <TableHeaderColumn dataField='trPaid' hidden={false} thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                >Zapłacono</TableHeaderColumn>
                <TableHeaderColumn dataField='trStatus' hidden={false} thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                                   dataFormat={(cell, row) => {
                                       if (cell==='TRUE') {
                                           return <div><i className={"fa fa-check"} style={{color: "forestgreen"}}></i> {cell}</div>
                                       }
                                       else {
                                           return <div>{cell}</div>
                                       }
                                   }}
                >Status</TableHeaderColumn>
            </BootstrapTable>

            <h5 style={{fontWeight: "bold", marginTop: "5px"}}>Logi biletów idBi</h5>
            <BootstrapTable data={this.state.logiBi}
                            options={{noDataText: 'Brak logów'}}
                            hover
            >
                <TableHeaderColumn dataField='id' isKey hidden={false} thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                >ID</TableHeaderColumn>
                <TableHeaderColumn dataField='dataWpisu' hidden={false} thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} dataSort
                                   dataFormat={(cell, row) => {
                                       return <div>{cell.replace("T", " ").substr(0, 19)}</div>
                                   }}
                >Data i godzina</TableHeaderColumn>
                <TableHeaderColumn dataField='idBi' thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                >idBi</TableHeaderColumn>
                <TableHeaderColumn dataField='idKu' thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                >idKu</TableHeaderColumn>
                <TableHeaderColumn dataField='event' hidden={false} thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4} dataSort
                >Event</TableHeaderColumn>
                <TableHeaderColumn dataField='opis' hidden={false} thStyle={tabgrid.tg6} tdStyle={tabgrid.tg6} dataSort
                >Opis</TableHeaderColumn>
                <TableHeaderColumn dataField='idUz' hidden={false} thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                >ID UZ</TableHeaderColumn>
                <TableHeaderColumn dataField='klientIp' hidden={false} thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} dataSort
                >UZ IP</TableHeaderColumn>
            </BootstrapTable>

            <h5 style={{fontWeight: "bold", marginTop: "5px"}}>Logi pozycji biletów idBp</h5>
            <BootstrapTable data={this.state.logiBp}
                            options={{noDataText: 'Brak logów'}}
                            hover
            >
                <TableHeaderColumn dataField='id' isKey hidden={false} thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                >ID</TableHeaderColumn>

                <TableHeaderColumn dataField='dataWpisu' hidden={false} thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} dataSort
                                   dataFormat={(cell, row) => {
                                       return <div>{cell.replace("T", " ").substr(0, 19)}</div>
                                   }}
                >Data i godzina</TableHeaderColumn>
                <TableHeaderColumn dataField='idBi' thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                >idBi</TableHeaderColumn>
                <TableHeaderColumn dataField='idKu' thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                >idKu</TableHeaderColumn>
                <TableHeaderColumn dataField='event' hidden={false} thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4} dataSort
                >Event</TableHeaderColumn>
                <TableHeaderColumn dataField='opis' hidden={false} thStyle={tabgrid.tg6} tdStyle={tabgrid.tg6} dataSort
                >Opis</TableHeaderColumn>
                <TableHeaderColumn dataField='idUz' hidden={false} thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                >ID UZ</TableHeaderColumn>
                <TableHeaderColumn dataField='klientIp' hidden={false} thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} dataSort
                >UZ IP</TableHeaderColumn>
            </BootstrapTable>


        </div>)
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyJednorazowe/components/bilety_kod_z_paragonu_components/BKLogiTable.js